import style from './GraficoContainer.module.css';

const GraficoContainer = ({ grafico }) => {

    let src;

    switch ( grafico ){
        case 'ATENDIMENTO AMBIENTAL':
            src = 'https://app.powerbi.com/view?r=eyJrIjoiMmM2M2RkY2ItNDAzMS00NGMwLTg3MjAtOTkyNWZkMjVlM2E4IiwidCI6IjI4NWYxOTg0LTExYmUtNDA1Yy1iY2U1LWUwMzY0Y2ZhM2EyNyJ9'
            break;
        case 'DESVIOS':
            src = 'https://app.powerbi.com/view?r=eyJrIjoiYjk5NjE4NGYtMWNlNS00MGZjLWE2YWYtZDBmZGY5ZDIwNTIxIiwidCI6IjI4NWYxOTg0LTExYmUtNDA1Yy1iY2U1LWUwMzY0Y2ZhM2EyNyJ9'
            break;
        case 'INSPEÇÃO DE CAMPO':
            src = 'https://app.powerbi.com/view?r=eyJrIjoiNjJjM2ZkOGQtMDJmZC00ZWEyLWI5NjMtOGYxNDhjYTFiNDIxIiwidCI6IjI4NWYxOTg0LTExYmUtNDA1Yy1iY2U1LWUwMzY0Y2ZhM2EyNyJ9'
            break;
        case 'INSPEÇÃO DE MEIO AMBIENTE':
            src = 'https://app.powerbi.com/view?r=eyJrIjoiMThlYTc3NjUtMWFlYS00OTcwLWJkODctNzJiZWI4NzFkNmYzIiwidCI6IjI4NWYxOTg0LTExYmUtNDA1Yy1iY2U1LWUwMzY0Y2ZhM2EyNyJ9'
            break;
        case 'TREINAMENTOS':
            src = 'https://app.powerbi.com/view?r=eyJrIjoiMDlmYmY3ZDMtZjAzZC00ZjRjLWFjNGYtNDBlYjg3ZDliNzYxIiwidCI6IjI4NWYxOTg0LTExYmUtNDA1Yy1iY2U1LWUwMzY0Y2ZhM2EyNyJ9'
            break;
        case 'REMA':
            src = 'https://app.powerbi.com/view?r=eyJrIjoiY2JlZmY1ZDktMWU5Yi00NzA5LWEyODMtYTliYzgyNzcyNWU0IiwidCI6IjI4NWYxOTg0LTExYmUtNDA1Yy1iY2U1LWUwMzY0Y2ZhM2EyNyJ9'
            break;
        default: return

    }

    return(
        <div className={ style.container } >
            <h2>{ grafico }</h2>
            <div className={ style.grafico } >
                <iframe
                    src={ src }
                    allowFullScreen={ true }
                />
            </div>
        </div>
    )

}

export default GraficoContainer;